






















import { Component, Vue, Inject } from 'vue-property-decorator';
import AliexpressOffers from '@/organisms/AliexpressOffers.vue';
import { Product } from '@/models/Product';


@Component({
	components: { AliexpressOffers }
})
export default class BestOffers extends Vue {
	keyword = '';
	activeTab = 1;
	zoomedProduct: Product = <any>{};

	zoomProduct(item: Product): void {
		this.zoomedProduct = item;
		(this.$refs.zoomModal as any).show();
	}
}
